import { Component } from '@angular/core';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html'
})
export class AppBodyComponent {}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/layouts/body/body.component.ts